import * as fromFaqCategories from './faq-categories.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'faq-categories';

export interface FaqCategoriesState {
  faqCategories: fromFaqCategories.FaqCategoriesState;
}

export const reducers: ActionReducerMap<FaqCategoriesState> = {
  faqCategories: fromFaqCategories.faqCategoriesReducer,
};

export const getFaqCategoriesState = createFeatureSelector<FaqCategoriesState>(featureKey);

export const metaReducers: MetaReducer<FaqCategoriesState>[] = !environment.production ? [] : [];
